module.exports = __webpack_public_path__ + "static/media/icRemittanceLifetime.b4737efd.svg";